import _ from "lodash";
import * as DateUtils from "../../../utils/date/date";
import { ContractPermission } from "../ContractPermission/ContractPermission";

export class AccountingContractManager {
    ContractPermission = new ContractPermission();

    constructor({ User } = {}) {
        this.User = User;

        const contracts = this.ContractPermission.getContractedsOfFeature({
            feature: "Themes"
        });

        this.features = {
            dashboardThemes: {
                permissionAllow: contracts,
                trial: { days: 7 }
            }
        };
    }

    hasPermission({ contract, user, feature, accountingPlanEntity } = {}) {
        const currentFeature = this.features[feature];

        if (accountingPlanEntity.isContractedFeature({ value: "Themes" }))
            return "allowed";

        const userStartedAt = _.get(
            user,
            `profile.trialContract.${feature}.startedAt`
        );

        if (!userStartedAt) {
            return "not-started";
        }

        const diff = DateUtils.getDifferenceInCalendarDays(
            new Date(),
            new Date(userStartedAt)
        );

        if (diff < currentFeature.trial.days) return "started";

        return "expired";
    }
}
